import type { UiAnimal } from './bridge';

/** Display only. Stored event text and pedigree identifiers stay unchanged. */
export function lifeLogLabel(text: string, animals: UiAnimal[]): string {
  const names = new Map<string,string>();
  for (const a of animals) {
    names.set(a.id, a.name);
    if(a.speciesId) names.set(a.speciesId,a.species.replace(/^./,c=>c.toUpperCase()));
  }
  return text.replace(/ext-gs-[\w-]+|\b[a-z][a-z0-9_]*-\d+\b|\b[a-z]+(?:_[a-z0-9]+)+\b/g,token=>token.startsWith('ext-gs-')?'External donor sire':names.get(token)??token);
}
